import { categories, mainSiteUrl } from '@/mocks/categories';
import { Link } from 'react-router-dom';

const footerLinks = {
  service: [
    { label: 'yoybuy sheet', url: mainSiteUrl },
    { label: 'Помощь', url: '#' },
    { label: 'Контакты', url: '#' },
  ],
  categories: categories.slice(0, 5).map((c) => ({ label: c.name, url: c.url })),
  guides: [
    { label: 'Руководство Yoybuy', url: '/yoybuy-sheet-guide' },
    { label: 'Сравнение систем', url: '/yoybuy-sheet-guide' },
    { label: 'Доставка в Европу', url: '/yoybuy-sheet-guide' },
  ],
  legal: [
    { label: 'Политика конфиденциальности', url: '#' },
    { label: 'Условия использования', url: '#' },
    { label: 'Возврат товаров', url: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 pt-20 pb-10">
      <div className="px-6 md:px-10 max-w-[1200px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-16 mb-20">
          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">Сервис</h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="space-y-2">
              {footerLinks.service.map((link) => (
                <a
                  key={link.label}
                  href={link.url}
                  target={link.url.startsWith('http') ? '_blank' : undefined}
                  rel={link.url.startsWith('http') ? 'noopener nofollow' : undefined}
                  className="block text-sm text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">Категории</h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="space-y-2">
              {footerLinks.categories.map((link) => (
                <a
                  key={link.label}
                  href={link.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">Гайды</h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="space-y-2">
              {footerLinks.guides.map((link) => (
                <Link
                  key={link.label}
                  to={link.url}
                  className="block text-sm text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">Правовая информация</h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="space-y-2">
              {footerLinks.legal.map((link) => (
                <a
                  key={link.label}
                  href={link.url}
                  className="block text-sm text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-300/60 pt-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 tracking-wide whitespace-nowrap">
                YOYBUY<span className="text-primary-500">.SBS</span>
              </span>
              <div className="w-12 h-px bg-background-300 my-3"></div>
              <p className="text-xs text-foreground-500 whitespace-nowrap">
                yoybuy.sbs — умный шопинг из Китая с табличной системой
              </p>
            </div>

            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-foreground-800 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-foreground-400 hover:text-foreground-800 transition-colors cursor-pointer" aria-label="Telegram">
                <i className="ri-telegram-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-foreground-400 hover:text-foreground-800 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>

            <p className="text-xs text-foreground-400 whitespace-nowrap">
              &copy; 2025 yoybuy.sbs
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}